export const lang = [{id: "es", name: "ES"}, {id: "en", name: "EN"}]
